import { render, staticRenderFns } from "./FeedBackSection.vue?vue&type=template&id=2c5ded40&scoped=true"
import script from "./FeedBackSection.vue?vue&type=script&lang=js"
export * from "./FeedBackSection.vue?vue&type=script&lang=js"
import style0 from "./FeedBackSection.vue?vue&type=style&index=0&id=2c5ded40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ded40",
  null
  
)

export default component.exports